var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmarkBlueBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.657,
    cy: 8.053,
    r: 7.541,
    fill: "#0C70D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.279 8.253 2.042 1.686 3.614-3.77"
  })));
}

export default SvgCheckmarkBlueBg;